export const TRANSMISSION_OPTIONS = [
  { value: "automatic",      label: "Automatic" },
  { value: "semi_automatic", label: "Semi-Automatic" },
  { value: "manual",         label: "Manual" },
];

export const FUEL_OPTIONS = [
  { value: "gasoline",        label: "Gasoline" },
  { value: "diesel",          label: "Diesel" },
  { value: "gasoline_hybrid", label: "Gasoline Hybrid" },
  { value: "diesel_hybrid",   label: "Diesel Hybrid" },
  { value: "plug_in_hybrid",  label: "Plug-in Hybrid" },
  { value: "electric",        label: "Electric" },
];

export const FUEL_LABEL_BY_VALUE  = Object.fromEntries(FUEL_OPTIONS.map((o) => [o.value, o.label]));
export const TRANS_LABEL_BY_VALUE = Object.fromEntries(TRANSMISSION_OPTIONS.map((o) => [o.value, o.label]));

/** Best-effort normaliser so legacy free-text values (Petrol, Gas,
 *  95 Unleaded, AT…) map cleanly onto the new dropdown options. */
export function normalizeFuel(raw) {
  const s = (raw || "").toLowerCase().replace(/[\s_-]+/g, "");
  if (!s) return "gasoline";
  if (s.includes("electric") || s === "ev" || s === "bev") return "electric";
  if (s.includes("plugin") || s === "phev") return "plug_in_hybrid";
  if (s.includes("dieselhybrid")) return "diesel_hybrid";
  if (s.includes("hybrid")) return "gasoline_hybrid";
  if (s.includes("diesel")) return "diesel";
  if (s.includes("petrol") || s.includes("gasoline") || s.includes("gas") || s.includes("unleaded")) return "gasoline";
  return "gasoline";
}

export function normalizeTransmission(raw) {
  const s = (raw || "").toLowerCase().replace(/[\s_-]+/g, "");
  if (!s) return "automatic";
  if (s.includes("semi") || s === "dsg" || s === "cvt") return "semi_automatic";
  if (s.includes("manual") || s === "mt") return "manual";
  return "automatic";
}

export const EMPTY_FORM = {
  group_code: "",
  name: "", brand: "", category: "luxury", transmission: "automatic", fuel: "gasoline",
  seats: 5, doors: 4, daily_rate: 100, image_url: "", description: "",
  features: [], allowed_extra_ids: [], location: "Downtown", locations: [],
  status: "active", available: true, rating: 4.7, year: 2024,
  disabled_dates: [], seasonal_rates: [], gallery: [],
  min_driver_age: 21, max_driver_age: 75,
  young_driver_threshold: 25, senior_driver_threshold: 72,
  young_driver_fee_per_day: 0, senior_driver_fee_per_day: 0,
  security_deposit_amount: 0, security_deposit_pct: 0,
  // v4.1.0 — Fleet Radar operations data.
  license_plate: "", current_odometer: 0,
  maintenance: {
    next_service_km: 0, next_service_date: "", next_kteo_date: "", insurance_expiry_date: "",
  },
};
